import type { AuthProviderToken } from "./types";

/**
 * Reads the `exp` claim of a JWT access token and reports whether it is in
 * the past. Returns false when the token can't be decoded, so callers fall
 * back to their existing behavior instead of treating it as expired.
 */
export const isAccessTokenExpired = (accessToken: string): boolean => {
  try {
    const payload = accessToken.split(".")[1];
    if (!payload) return false;
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const { exp } = JSON.parse(atob(base64)) as { exp?: number };
    return typeof exp === "number" && exp * 1000 <= Date.now();
  } catch {
    return false;
  }
};

/**
 * LTI tokens have no refresh_token, so once expired the session can't recover
 * and the teacher has to relaunch from Moodle.
 */
export const isLtiSessionExpired = (
  token: AuthProviderToken | null
): boolean =>
  token?.authOrigin === "lti" && isAccessTokenExpired(token.access_token);
